import { DOWNLOAD_CONSULTANT_RATING_EXCEL, GET_CONSULTANT_RATINGS_DATA } from "../../../constants";

export function getConsultantRatings(data) {
    return {
        type: GET_CONSULTANT_RATINGS_DATA,
        data,
    };
}

export function downloadConsultantRatingsExcel(data) {
    return {
        type: DOWNLOAD_CONSULTANT_RATING_EXCEL,
        data,
    };
}
